import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '漫画分类', href: '/category/romance' },
  { label: '排行榜', href: '/category/action' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-400 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-lg border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-6 md:px-10 flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
            漫
          </span>
          <span className={`text-lg font-heading font-bold tracking-wide transition-colors ${
            scrolled || !isHome ? 'text-foreground-950' : 'text-white'
          }`}>
            动漫之家
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-label font-medium whitespace-nowrap transition-colors duration-200 relative py-1 ${
                location.pathname === link.href
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-white'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
              {location.pathname === link.href && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-500 rounded-full" />
              )}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/category/romance"
            className="whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-label font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-label font-medium py-2 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category/romance"
            className="whitespace-nowrap mt-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-label font-semibold text-center cursor-pointer"
          >
            开始阅读
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      )}
    </header>
  );
}